import { cx } from '@emotion/css';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { Button, InputAdornment } from '@mui/material';
import React from 'react';
import { makeStyles, useTheme } from '../../../../../../styles';
const useStyles = makeStyles({
    root: {
        transition: 'opacity 250ms',
        opacity: 0,
        pointerEvents: 'none',
    },
    visible: {
        opacity: 1,
        pointerEvents: 'auto',
    },
});
const getInputAdornmentWithContent = (content) => React.createElement(InputAdornment, { position: "end" }, content);
export function InputEndAdornment({ confirmButtonId, discardButtonId, success, customEndAdornment, valueChanged, withConfirmationButtons, handleCancel, handleConfirm, }) {
    const theme = useTheme();
    const classes = useStyles();
    if (withConfirmationButtons) {
        return (React.createElement(InputAdornment, { position: "end", className: cx(classes.root, {
                [classes.visible]: valueChanged,
            }) },
            React.createElement(Button, { color: "primary", disableElevation: true, id: confirmButtonId, variant: "contained", onClick: handleConfirm },
                React.createElement(CheckIcon, { fontSize: "inherit" })),
            React.createElement(Button, { color: "primary", disableElevation: true, id: discardButtonId, variant: "outlined", onClick: handleCancel },
                React.createElement(ClearIcon, { fontSize: "inherit" }))));
    }
    if (customEndAdornment) {
        return getInputAdornmentWithContent(customEndAdornment);
    }
    if (success) {
        return getInputAdornmentWithContent(React.createElement(CheckIcon, { fontSize: "small", htmlColor: theme.colors.success.main }));
    }
    return null;
}
//# sourceMappingURL=InputEndAdornment.js.map